(function () {
    const form = document.getElementById('newsletter-subscribe');
    const successMessage = document.getElementById('success-message');

    if (form && successMessage) {
        const submitButton = form.querySelector('button[type="submit"]');
        const errorMessage = form.querySelector('.msn-error');

        form.addEventListener('submit', (e) => {
            e.preventDefault();
            errorMessage.classList.add('d-none');

            fetch(form.dataset.action, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(Object.fromEntries(new FormData(form))),
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.success) {
                        successMessage.classList.remove('d-none');
                        form.classList.add('d-none');

                        document.dispatchEvent(new CustomEvent('Newsletter_Subscribe'));
                    } else {
                        let errorHtml = '';
                        Object.values(JSON.parse(data.errors)).forEach((error) => {
                            errorHtml += `<p>${error}</p>`;
                        });
                        errorMessage.querySelector('.content').innerHTML = errorHtml;
                        errorMessage.classList.remove('d-none');

                        document.dispatchEvent(new CustomEvent('Newsletter_Subscribe_Error'));
                    }

                    submitButton.classList.remove('loading');
                    window.scrollTo(0, 0);
                })
                .catch(() => {});
        });
    }
})();
